import React from "react";
import { Route } from "react-router";
import useAuth from "modules/auth/hooks/useAuth";
import LandingPage from "modules/app/pages/LandingPage";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useI18n } from "i18n";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";

interface IAuthenticatedRoute {
  UnauthenticatedPage: React.ComponentType;
  defaultUrl?: string;
  path: string;
}

const AuthenticatedRoute = ({
  UnauthenticatedPage,
  defaultUrl,
  path,
}: IAuthenticatedRoute): JSX.Element => {
  const auth = useAuth();
  const { t } = useI18n();
  const { redirectTo } = useQueryParams();

  if (auth.isLoading) {
    return <PageLoader message={t("loading")} />;
  }
  return (
    <Route strict exact path={path}>
      {auth.isAuthenticated ? (
        <LandingPage defaultUrl={defaultUrl} redirectTo={redirectTo} />
      ) : (
        <UnauthenticatedPage />
      )}
    </Route>
  );
};

export default AuthenticatedRoute;
